import React from "react";
import { Provider } from "react-redux";
import Store from "@/redux/store";
import Context from "@/context/Context";
import PageHead from "@/pages/Head";
import FooterOne from "@/components/Footer/Footer-One";
import HeaderBasic from "@/components/Header/HeaderStyle-Four";
import MobileMenu from "@/components/Header/MobileMenu";
import BackToTop from "@/pages/backToTop";
import Separator from "@/components/Common/Separator";
import BreadCrumb from "@/components/Common/BreadCrumb";
import Image from "next/image";
import periodismoImg from "../../public/images/seedbed/periodismo.jpg";
import floraImg from "../../public/images/seedbed/flora.jpg";
import roboticaImg from "../../public/images/seedbed/robotica.jpg";
import turismoImg from "../../public/images/seedbed/turismo.jpg"
import semilleritosImg from "../../public/images/seedbed/suculentas.jpg";
import artesanalImg from "../../public/images/seedbed/artesanal.jpg";
import arcillaImg from "../../public/images/seedbed/arcilla.jpg";
import senaImg from "../../public/images/seedbed/sena.jpg";
import culinariaImg from "../../public/images/seedbed/culinaria.jpg";


const Seedbed = () => {
  return (
    <>
      <PageHead title="Semilleros - Colegio Menfis" />
      <Provider store={Store}>
        <Context>
          <HeaderBasic headerSticky="rbt-sticky" headerType="" />
          <MobileMenu />
          <BreadCrumb title="Semilleros de Investigación: Inspiración y Aprendizaje en Acción" text="Semilleros de Investigación" />
          <div className=" bg-color-white mt--30 flex-center">
            <div className="container col-lg-8">
              <h4 className="title">
                ¿Qué son nuestros Semilleros de Investigación?
              </h4>
              <p className="description mt--15 mb--30">
                En nuestro colegio les ofrecemos espacios donde la curiosidad y el asombro se convierten en aprendizaje práctico y divertido. Diseñados para desarrollar en nuestros estudiantes habilidades investigativas, blandas, sus capacidades en trabajo cooperativo, y principios de emprendimiento con la comercialización de sus productos, estos programas inspiran a los estudiantes desde una edad temprana hasta el bachillerato. Los estudiantes eligen su semillero a través de una rotación durante el primer mes de clases.
              </p>
              <h4 className="title">
                Innovación y Desarrollo
              </h4>
              <p className="description mt--15 mb--15">
                Nuestros semilleros refuerzan el conocimiento en diferentes áreas, incluyendo oratoria en ambos idiomas, y fomentan la socialización en temas diversos.
              </p>
              <p className="description">
                Cada Semillero de Investigación está diseñado para cultivar el interés y la pasión de nuestros Menfisianos en diversas áreas del conocimiento. Creemos en el poder de la exploración y el aprendizaje práctico para preparar a nuestros estudiantes para enfrentar los desafíos del futuro con confianza y creatividad.
              </p>
            </div>
          </div>
          <div className=" bg-color-white rbt-section-gap2Top" id="semilleritos">
            <div className="container">
              <div className="row g-5 align-items-center flex-center row-reverse">
                <div className="col-lg-5">
                  <Image
                    className="w-100 rbt-radius"
                    src={semilleritosImg}
                    width={407}
                    height={638}
                    property="true"
                    alt="Semilleritos image"
                  />
                </div>
                <div className="col-lg-5">
                  <div className="inner pl--50 pl_lg--0 pl_md--0 pl_sm--0">
                    <h4 className="title">Semilleritos</h4>
                    <p className="description mt--30">
                      <b>Little Farmers (Prejardín y Jardín)</b><br/>Exploración de la naturaleza mediante la creación y cuidado de una huerta orgánica. <b>Docente: Diana Real</b>
                    </p>
                    <p className="description mt--30">
                      <b>Jardín de Suculentas (Transición A)</b><br/> Cuidado de suculentas, desde la plantación hasta la comercialización. <b>Docente: Thalia Zuluaga</b>
                    </p>
                    <p className="description mt--30">
                      <b>Semillitas de Colores (Transición B)</b><br/> Cultivo de sabilas, aprendiendo sobre la planta y valores como responsabilidad y trabajo en equipo.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="bg-color-white rbt-section-gap2Top" id="periodismo">
            <div className="container">
              <div className="row g-5 align-items-center flex-center">
                <div className="col-lg-5">
                  <Image
                    className="w-100 rbt-radius"
                    src={periodismoImg}
                    width={550}
                    height={600}
                    property="true"
                    alt="periodismo image"
                  />
                </div>
                <div className="col-lg-5">
                  <div className="inner pl--50 pl_lg--0 pl_md--0 pl_sm--0">
                    <h4 className="title">Periodismo y Comunicación</h4>
                    <p className="description mt--30">
                      Los estudiantes exploran el mundo de los medios y la comunicación, desarrollando habilidades en redacción, investigación, expresion corporal y oral. Aprenden a contar historias de manera efectiva y a utilizar la comunicación como herramienta de cambio. <b>Docentes: Sandra Milena Saldarriaga - Cristian Guzmán</b>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className=" bg-color-white rbt-section-gap2Top" id="flora">
            <div className="container">
              <div className="row g-5 align-items-center flex-center row-reverse">
                <div className="col-lg-5">
                  <Image
                    className="w-100 rbt-radius"
                    src={floraImg}
                    width={407}
                    height={638}
                    property="true"
                    alt="Flora image"
                  />
                </div>
                <div className="col-lg-5">
                  <div className="inner pl--50 pl_lg--0 pl_md--0 pl_sm--0">
                    <h4 className="title">Investigación Natural - Flora</h4>
                    <p className="description mt--30">
                      Este semillero permite a los estudiantes investigar y comprender la flora local y global, promoviendo el conocimiento sobre la biodiversidad y las prácticas de conservación. Su propósito para este año es trabajar en el embellecimiento de las zonas comunes de la institución y sembrar plantas florales que atraigan colibríes y aumenten el avistamiento de aves.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="bg-color-white rbt-section-gap2Top" id="robotica">
            <div className="container">
              <div className="row g-5 align-items-center flex-center">
                <div className="col-lg-5">
                  <Image
                    className="w-100 rbt-radius"
                    src={roboticaImg}
                    width={550}
                    height={600}
                    property="true"
                    alt="Robótica image"
                  />
                </div>
                <div className="col-lg-5">
                  <div className="inner pl--50 pl_lg--0 pl_md--0 pl_sm--0">
                    <h4 className="title">Robótica</h4>
                    <p className="description mt--30">
                      En nuestro semillero introducimos los conceptos básicos de la robótica, los estudiantes practican desde el funcionamiento de mecanismos hidraulicos y electronicos hechos con craft,  hasta las bases de la programación en plataformas como Scratch; donde los niños pueden crear sus propias animaciones… Fomentamos habilidades esenciales como la resolución de problemas, la lógica y la perseverancia.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className=" bg-color-white rbt-section-gap2Top" id="turismo">
            <div className="container">
              <div className="row g-5 align-items-center flex-center row-reverse">
              <div className="col-lg-5">
                  <Image
                    className="w-100 rbt-radius"
                    src={turismoImg}
                    width={407}
                    height={638}
                    property="true"
                    alt="Turismo image"
                  />
                </div>
                <div className="col-lg-5">
                  <div className="inner pl--50 pl_lg--0 pl_md--0 pl_sm--0">
                    <h4 className="title">Turismo</h4>
                    <p className="description mt--30">
                      Los alumnos investigan el impacto del turismo en diferentes regiones, aprendiendo sobre la importancia del desarrollo sostenible y la preservación cultural.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="bg-color-white rbt-section-gap2Top" id="artesanal">
            <div className="container">
              <div className="row g-5 align-items-center flex-center">
                <div className="col-lg-5">
                  <Image
                    className="w-100 rbt-radius"
                    src={artesanalImg}
                    width={550}
                    height={600}
                    property="true"
                    alt="Artesanal image"
                  />
                </div>
                <div className="col-lg-5">
                  <div className="inner pl--50 pl_lg--0 pl_md--0 pl_sm--0">
                    <h4 className="title">Artesanal</h4>
                    <p className="description mt--30">
                      Este semillero promueve la creatividad y la habilidad manual a través de la creación de artesanías, fomentando la apreciación de técnicas tradicionales y la expresión artística.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className=" bg-color-white rbt-section-gap2Top" id="arcilla">
            <div className="container">
              <div className="row g-5 align-items-center flex-center row-reverse">
                <div className="col-lg-5">
                  <Image
                    className="w-100 rbt-radius"
                    src={arcillaImg}
                    width={407}
                    height={638}
                    property="true"
                    alt="arcilla image"
                  />
                </div>
                <div className="col-lg-5">
                  <div className="inner pl--50 pl_lg--0 pl_md--0 pl_sm--0">
                    <h4 className="title">Arcilla</h4>
                    <p className="description mt--30">
                      Los estudiantes exploran el trabajo con arcilla, desarrollando habilidades en modelado y cerámica, y apreciando la importancia del arte en la cultura y la historia.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="bg-color-white rbt-section-gap2Top" id="sena">
            <div className="container">
              <div className="row g-5 align-items-center flex-center">
                <div className="col-lg-5">
                  <Image
                    className="w-100 rbt-radius"
                    src={senaImg}
                    width={550}
                    height={600}
                    property="true"
                    alt="Sena biotec image"
                  />
                </div>
                <div className="col-lg-5">
                  <div className="inner pl--50 pl_lg--0 pl_md--0 pl_sm--0">
                    <h4 className="title">Biotecnología - SENA</h4>
                    <p className="description mt--30">
                      En colaboración con el SENA, los estudiantes se adentran en el campo de la biotecnología, investigando aplicaciones prácticas de la ciencia en la salud y el medio ambiente
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className=" bg-color-white rbt-section-gap2Top mb--45" id="culinaria">
            <div className="container">
              <div className="row g-5 align-items-center flex-center row-reverse">
                <div className="col-lg-5">
                  <Image
                    className="w-100 rbt-radius"
                    src={culinariaImg}
                    width={407}
                    height={638}
                    property="true"
                    alt="culinaria image"
                  />
                </div>
                <div className="col-lg-5">
                  <div className="inner pl--50 pl_lg--0 pl_md--0 pl_sm--0">
                    <h4 className="title">Culinaria</h4>
                    <p className="description mt--30">
                      Los alumnos descubren el arte de la cocina, aprendiendo sobre nutrición, técnicas culinarias y la importancia de una alimentación saludable.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Separator />
          <BackToTop />
          <FooterOne />
        </Context>
      </Provider>
    </>
  );
};

export default Seedbed;
